export const initialState = {
    is_loading: true,
    ftms: [],
    page_number: 1,
    serach_text: '',
    ftm_stages: [],
    sort_key: '',
    sort_direction: ''
}